export function SettingIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M5.83333 2.5V5H2.5V6.66667H5.83333V9.16667H7.5V2.5H5.83333ZM9.16667 6.66667H17.5V5H9.16667V6.66667ZM14.1667 10.8333V13.3333H17.5V15H14.1667V17.5H12.5V10.8333H14.1667ZM10.8333 15H2.5V13.3333H10.8333V15Z" fill="currentColor" />
    </svg>
  );
}

SettingIcon.displayName = 'SettingIcon';